import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/icons/odo.png';
import { usePageTitle } from '../hooks/usePageTitle';

const Forbidden: React.FC = () => {
    usePageTitle('Forbidden');
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center py-12 px-4">
            <div className="absolute top-10">
                <img src={logo} alt="logo" className="h-10 w-auto" />
            </div>

            <div className="w-full max-w-md text-center">
                <div className="bg-white py-10 px-8 shadow-lg rounded-xl">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg
                            className="w-8 h-8 text-red-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                            />
                        </svg>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
                    <p className="text-gray-500 mb-8">
                        You do not have admin privileges to access the Admin Dashboard.
                    </p>
                    <button
                        onClick={() => navigate('/login')}
                        className="bg-gray-800 text-white px-6 py-2 rounded-lg hover:bg-gray-900 transition-colors font-medium text-sm"
                    >
                        Back to Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export { Forbidden };
